/**
 * 本人確認申請用データストア
 *
 */

/**
 * ステート定義、デフォルト値
 * @returns
 */
const getDefaultState = () => {
  return {
    // 受付番号
    receiptNo: "",
    //アクセスキー
    accesskey: "",
    // システムID
    systemId: "",
    // 申請者氏名
    appName: "",
    // 申請者性別
    appSexKbn: "",
    // 申請者生年月日
    appBirthday: "",
    // 選択申請書類区分
    // ex {cd: "10", name: "運転免許証"}
    selectedAppDocKbnInfo: {},
    // データリスト
    // ex [{cd: "10", name: 表面の書類写真データ}, {cd: "20", name: 斜め表面の書類写真データ}, {cd: "30", name: 裏面の書類写真データ}, {cd: "40", name: 顔の正面の写真データ}, {cd: "50", name: 顔の斜めの写真データ}]
    appDataList: [],
  };
};

/**
 * ステート
 */
const state = getDefaultState();

/**
 * ゲッター
 */
const getters = {
  getReceiptNo(state) {
    return state.receiptNo;
  },
  getAccesskey(state) {
    return state.accesskey;
  },
  getSystemId(state) {
    return state.systemId;
  },
  getAppName(state) {
    return state.appName;
  },
  getAppSexKbn(state) {
    return state.appSexKbn;
  },
  getAppBirthday(state) {
    return state.appBirthday;
  },
  getSelectedAppDocKbnInfo(state) {
    return state.selectedAppDocKbnInfo;
  },
  getAppDataList(state) {
    return state.appDataList;
  },
};

/**
 * ミューテーション
 */
const mutations = {
  receiptNo(state, status) {
    state.receiptNo = status;
  },
  accesskey(state, status) {
    state.accesskey = status;
  },
  systemId(state, status) {
    state.systemId = status;
  },
  appName(state, status) {
    state.appName = status;
  },
  appSexKbn(state, status) {
    state.appSexKbn = status;
  },
  appBirthday(state, status) {
    state.appBirthday = status;
  },
  selectedAppDocKbnInfo(state, status) {
    state.selectedAppDocKbnInfo = status;
  },
  appDataList(state, status) {
    state.appDataList = status;
  },
  /**
   * state初期化
   * @param {ストア}} state
   */
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
};

/**
 * アクション
 */
const actions = {
  setReceiptNo(context, info) {
    context.commit("receiptNo", info);
  },
  setAccesskey(context, info) {
    context.commit("accesskey", info);
  },
  setSystemId(context, info) {
    context.commit("systemId", info);
  },
  setAppName(context, info) {
    context.commit("appName", info);
  },
  setAppSexKbn(context, info) {
    context.commit("appSexKbn", info);
  },
  setAppBirthday(context, info) {
    context.commit("appBirthday", info);
  },
  setSelectedAppDocKbnInfo(context, info) {
    context.commit("selectedAppDocKbnInfo", info);
  },
  setAppDataList(context, info) {
    context.commit("appDataList", info);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
